import { CoreItemType } from './core-item';

export class SubDataConverter {
  static fromFrontendToBackend(coreItemType: CoreItemType, subData: any) {
    return subData;
  }

  static fromBackendToFrontend(coreItemType: CoreItemType, subData: any) {
    return subData;
  }
}
